<template>
<div class="chapter">
<div class="inner_page">
<div id="copyright">
<p><strong><em>AMERICAN MASTERS</em> is a production of THIRTEEN for PBS<br/>Creator + Executive Producer: Susan Lacy<br/>Series Producer: Prudence Glass<br/>Supervising Producer: Julie Sacks</strong></p>
<p><strong>Text copyright © 2013 by Elizabeth Partridge.<br/>Photographs copyright © by Dorothea Lange Collection, Oakland Museum of California, the City of Oakland. Gift of Paul S. Taylor, unless otherwise noted.<br/>All rights reserved. No part of this book may be reproduced in any form without written permission from the publisher.</strong></p>
<p><strong><a href="#/xhtml/21endnotes#page_188">Page 188</a> constitutes a continuation of the copyright page.</strong></p>
<p><strong>ISBN 978-1-4521-3196-2<br/>The Library of Congress has cataloged the print edition under: ISBN: 978–1–4521–2216–8.</strong></p>
<p><strong>Design: Annabelle Gould<br/>Typeset with National by Kris Sowersby</strong></p>
<p><strong>Frontis image: <em>Migrant Mother</em>, 1936</strong></p>
<p><strong>Chronicle Books LLC<br/>680 Second Street<br/>San Francisco, CA 94107</strong></p>
<p><strong><a href="http://www.chroniclebooks.com" target="_blank">www.chroniclebooks.com</a></strong></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05-copyright.vue?389f61c6